import { API_ROUTE_ADMIN_FEATURE_DETAILS } from '@/resources/api-routes'
import { get } from '@/util/auth'

const IS_NEW_BACKEND_API = true

type FeatureDetailsOriginal = {
  id: number
  name: string
  description: string
  active: number
  activationUrl: string | null
  deactivationUrl: string | null
  customerFeatures: {
    id: number
    customerId: number
    statusId: number | null | undefined
    logs: {
      id: number
      action: string
      timestamp: string
      user: {
        id: number
        firstName: string
        lastName: string
        email: string
      }
    }[]
  }[]
}

export const getFeatureDetails = (featureId: number) =>
  get<FeatureDetailsOriginal>(
    API_ROUTE_ADMIN_FEATURE_DETAILS.replace(':featureId', String(featureId)),
    IS_NEW_BACKEND_API
  )
